import type { ReactNode } from "react";

export interface ProductReviewNewViewProps {
  /** The wired review form modal (routed modal + Inertia form) supplied by the container. */
  children: ReactNode;
}

/**
 * Presentational shell for the product review modal route. This page is a thin
 * wrapper: all wiring (route path, Inertia form, routed modal) lives in the container
 * (`new.tsx`) and is passed in as `children`; this simply renders that composition.
 */
export function ProductReviewNewView({ children }: ProductReviewNewViewProps) {
  return <>{children}</>;
}
